var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { InputAdornment, TextField } from "@material-ui/core";
import { NonInputField } from "./NonInputField";
export const NonInputableField = (_a) => {
    var _b;
    var { changed = false } = _a, rest = __rest(_a, ["changed"]);
    if (rest.disabled)
        return (_jsx(NonInputField, { multiline: rest.multiline, label: rest.label, value: ((_b = rest.value) !== null && _b !== void 0 ? _b : ""), changed: changed }, void 0));
    return (_jsx(TextField, Object.assign({ fullWidth: true, variant: "outlined" }, rest, { color: "primary", InputProps: changed
            ? {
                endAdornment: (_jsx(InputAdornment, Object.assign({ position: "end" }, { children: "modifi\u00E9" }), void 0)),
            }
            : {} }), void 0));
};
//# sourceMappingURL=index.js.map